import { queryOptions } from '@tanstack/react-query'
import { merkl } from '../merkl'

const QUERY_REFETCH_INTERVAL = 60_000 // 1 minute

// interface OpportunitiesQueryParams {}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function opportunitiesQueryOptions() {
  return queryOptions({
    queryKey: opportunitiesQueryKey(),
    queryFn: async () => {
      const opportunities = await merkl.opportunities.index.get({
        query: {
          mainProtocolId: 'hypurrfi',
        },
      })

      return opportunities.data
    },
    refetchInterval: QUERY_REFETCH_INTERVAL,
  })
}

export function opportunitiesQueryKey(): unknown[] {
  return ['merkl', 'opportunities']
}
